export default __webpack_public_path__ + "static/media/gallery-4.d28b6d02.jpg";